import styled from 'styled-components';
import { getTransition, mq, px2rem } from '../../../stylesheets/tools';

const StyledShareBox = styled.aside`
  ${props =>
    !props.staticHor &&
    'position:absolute; top:0; left: 0; margin: 0 0 0 -10px; z-index: 90; display: flex; align-items: flex-end;'};

  ${mq('m')} {
    margin: 0;
  }

  @media print {
    display: none;
  }

  .sharebox__wrapper {
    display: flex;
    width: 100%;
    align-items: flex-start;
    ${props => (props.staticHor ? 'gap: 16px' : 'flex-direction: column')};

    ${mq('m')} {
      align-items: flex-start;
    }

    a {
      ${props => !props.staticHor && 'margin: 5px 0'};
      cursor: pointer;

      [data-whatinput='mouse'] &,
      [data-whatinput='touch'] & {
        outline: 0;
      }

      svg {
        width: ${px2rem('25px')};
        height: ${px2rem('25px')};
        ${getTransition('defaultFast')}
      }

      &:hover {
        svg {
          transform: scale(1.07);
        }

        g,
        path {
          fill: ${props => props.theme.siteTheme.borderColor};
        }
      }
    }

    a.copied {
      background: green;
    }
  }
`;

export default StyledShareBox;
